import React, { useEffect, useState } from 'react'
import { CircleCheckIcon } from '../../../Icons/CircleCheckIcon'
import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { useTranslation } from 'react-i18next'
import { useAssetTypesState } from '../../../../stores/Configuration/AssetTypesProvider'
import { emptyGuid, isEmptyGuid } from '../../../../utils/emptyGuid'
import { isEmptyDate } from '../../../../utils/emptyDate'
import { defaultTemplate, checkConfigOption } from '../../../../utils/assetTypeConfigurations'
import { isEmptyStr } from '../../../../utils/objectutils'
import { cloneDeep } from 'lodash'

const MainDataCheck = ({ mainData }) => {
  const [isValid, setIsValid] = useState(false)
  const { t } = useTranslation()
  const { assetTypes } = useAssetTypesState()
  const [fieldConfiguration, setFieldConfiguration] = useState(cloneDeep(defaultTemplate))
  const [isGrouped, setIsGrouped] = useState(false)
  useEffect(() => {
    let type = assetTypes.find(item => item.id === (mainData.type?.id??emptyGuid));
    setIsGrouped(false)
    if (type) {
      setFieldConfiguration(JSON.parse(type.fieldConfiguration))
      setIsGrouped(type.isGrouped)
    }
  }, [assetTypes, mainData.type.id])
  useEffect(() => {
    if (!!mainData.name
      && !(checkConfigOption('mandatory', fieldConfiguration.timeSpan?.option) && isEmptyDate(mainData.timeSpanStartDate))
      && !(checkConfigOption('mandatory', fieldConfiguration.timeSpan?.option) && isEmptyDate(mainData.timeSpanEndDate))
      && !(checkConfigOption('mandatory', fieldConfiguration.comment?.option) && isEmptyStr(mainData.comment))
      && !(isEmptyStr(fieldConfiguration.number?.numberrange) && isEmptyStr(mainData.number))
      && !(isGrouped && isEmptyGuid(mainData.group?.id))
      && !(!isGrouped && isEmptyGuid(mainData.costCenter?.id))
      && !(!isGrouped && isEmptyGuid(mainData.office?.id))) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [isGrouped, mainData, fieldConfiguration])

  return (
    <>
      <StyledCircleCheckIconWrapper>
        <CircleCheckIcon variant={isValid ? 'done' : 'must'} />
      </StyledCircleCheckIconWrapper>
      <span>{t('OverlayProgress:mainData')}</span>
    </>
  )
}

export default MainDataCheck
